import script from "./Callback.vue?vue&type=script&setup=true&lang=js"
export * from "./Callback.vue?vue&type=script&setup=true&lang=js"

import "./Callback.vue?vue&type=style&index=0&id=669299b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-669299b8"]])

export default __exports__